import { EssentialPersistedTab } from 'apiConnector/tabs/tabs.model';
import { ProductVariationValidSyntax } from 'models/productsReferential';
import { AppState } from 'state/state.model';
import { WorkspaceTab } from 'state/workspaces/tabs/tabs.model';

export function getWorkspaceEssentialTabQuoteId(state: AppState, tabId: string) {
  return state.workspaces.essential[tabId]?.quoteId;
}
export function isWorkspaceEssentialTabUnderlyingsResultExpanded(state: AppState, tabId: string) {
  return state.workspaces.essential[tabId]?.isUnderlyingsResultExpanded ?? false;
}

export function selectEssentialWorkspaceTabProductVariation(
  state: AppState,
  formId: string,
): ProductVariationValidSyntax | undefined {
  const productVariation = state.workspaces.essential[formId]?.productVariation;

  if (!productVariation) {
    return undefined;
  }

  return productVariation.productType && productVariation.productSubtype && productVariation.wrapper
    ? {
        productType: productVariation.productType,
        productSubtype: productVariation.productSubtype,
        wrapper: productVariation.wrapper,
      }
    : undefined;
}

export function getPersistedTabFromEssentialWorkspaceTab(state: AppState, tab: WorkspaceTab): EssentialPersistedTab {
  return {
    ...tab,
    workspace: 'essential',
    tabContentType: 'primary',
    quoteId: getWorkspaceEssentialTabQuoteId(state, tab.id),
    isUnderlyingsResultExpanded: isWorkspaceEssentialTabUnderlyingsResultExpanded(state, tab.id),
    isPayoffGraphHidden: isPayoffGraphHiddenInEssentialWorkspaceTab(state, tab.id),
    productVariation: selectEssentialWorkspaceTabProductVariation(state, tab.id),
  };
}

export function getWorkspaceEssentialTabProductValidation(state: AppState, tabId: string) {
  return state.workspaces.essential[tabId]?.isProductValidated;
}

export function isPayoffGraphHiddenInEssentialWorkspaceTab(state: AppState, tabId: string) {
  return state.workspaces.essential[tabId]?.isPayoffGraphHidden ?? false;
}

export function selectWorkspaceEssentialTabProductLayout(state: AppState, tabId: string) {
  return state.workspaces.essential[tabId]?.productLayout;
}
